export const helpCenterSectionAdapter = (data) => {
  if (data.courses) {
    return {
      id: data.section.id,
      caption: data.section.caption,
      description: data.section.description,
      meta_title: data.section.meta_title,
      meta_description: data.section.meta_description,
      slug: data.section.slug,
      items: data.courses.map((item) => ({
        id: item.id,
        caption: item.caption,
        description: item.description,
        section_id: item.section_id,
        cover: item.cover,
        slug: item.slug,
        time: item.reading_time,
        bgcolor: item.bgcolor,
      })),
    };
  }

  return {
    id: data.section.id,
    caption: data.section.caption,
    description: data.section.description,
    meta_title: data.section.meta_title,
    meta_description: data.section.meta_description,
    slug: data.section.slug,
    currentCategory: data.subsection === null ? 'all' : data.subsection.slug,
    isCurrentCategoryHidden:
      data.subsection === null ? false : data.subsections?.find((item) => item.id === data.subsection.id).hidden,
    categories: data.subsections
      .filter((item) => item.size > 0)
      .map((item) => ({
        id: item.id,
        caption: item.caption,
        slug: item.slug,
        isHidden: item.hidden || false,
      })),
    items: data.pages.map((item) => ({
      id: item.id,
      caption: item.caption,
      description: item.description,
      cover: item.cover,
      slug: item.slug,
      category: data.subsections.find((subsection) => subsection.id === item.subsection_id).slug,
      time: item.reading_time,
      bgcolor: item.bgcolor,
    })),
    total: data.total,
    currentPage: data.currentPage,
  };
};
